<template>
	<div class="page-header">
		<div class="header-content">
			<div class="title">
				<h1>{{ pageTitle }}</h1>
				<h2>{{ pageSubtitle }}</h2>
			</div>
			<div class="cta">
				<slot name="cta"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["pageTitle", "pageSubtitle"],
	
}
</script>

<style scoped>
.page-header {
	margin-bottom: 8px;
	margin: 0px;
	width: 100%;
	position: relative;
	color: #fff;
}

.page-header .title {
	flex-grow: 1;
}
.page-header .title h1 {
	font-size: 1rem;
	font-weight: 500;
	text-align: center;
}
.page-header .title h2 {
	font-size: 0.8rem;
	font-weight: 500;
	text-align: center;
}
.page-header .header-content {
	padding: 8px 16px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
</style>
